<template>
	<div class="content">
		<h3>经销商库存查询</h3>
		<div class="item">
			<el-form ref="form" :inline="true" :model="form" label-width="100px">
				
				<el-form-item label="经销商层级">
					<el-input v-model="form.username" clearble></el-input>
				</el-form-item>
                <el-form-item label="经销商">
					<el-input v-model="form.username" clearble></el-input>
				</el-form-item>
                
			</el-form>
			<div class="btn">
				<el-button type="primary">查 询</el-button>
                <el-button type="primary">数据下载</el-button>
			</div>
		</div>
		<div class="item">
			<el-table :data="tableData" border>
				<el-table-column align="center" label="经销商层级"></el-table-column>
				<el-table-column align="center" label="经销商编号"></el-table-column>
				<el-table-column align="center" label="经销商名称"></el-table-column>
				<el-table-column align="center" label="父级经销商编号"></el-table-column>
				<el-table-column align="center" label="父级经销商名称"></el-table-column>
                <el-table-column align="center" label="产品名称"></el-table-column>
                <el-table-column align="center" label="库存数量(最小包装)"></el-table-column>
			</el-table>
			<el-pagination
                background
                @current-change="handleCurrentChange"
                layout="total,prev, pager, next,jumper"
                :total="pageNum"
                :page-size="10">
                </el-pagination>
		</div>
	</div>
</template>

<script>
export default {
	data(){
		return {
			form: {
				username: '',
				name: '',
				value: null
			},
			options: [{
				value: '选项1',
				label: '黄金糕'
				}, {
				value: '选项2',
				label: '双皮奶'
			}],
			tableData: [],
			pageNum:0,
		}
	}
}
</script>

<style scoped>
.title{
  text-align: left;
}
.btn{
	width: 500px;
	margin:0 100px;
}
.el-form--inline .el-form-item{
    width:300px;
}
.el-input {
	width:220px;
}
</style>


// WEBPACK FOOTER //
// src/pages/EnDealerStock.vue